'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('viewpoints', {
      abstract: true,
      url: '/viewpoints',
      template: '<ui-view />',
      theme: 'dark'
    })
    .state('viewpoints.view', {
      url: '/:id',
      template: '<trueviews></trueviews>',
      theme: 'dark'
    });
}



// WEBPACK FOOTER //
// ./client/app/viewpoints/viewpoints.routes.js